import { render, staticRenderFns } from "./PurchaseOrdersTable.vue?vue&type=template&id=3faff71c&scoped=true&"
import script from "./PurchaseOrdersTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faff71c",
  null
  
)

export default component.exports